import FilledButtonM from "@common/components/button/FilledButtonM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import React, { useContext } from "react"
import { ScrollView, View } from "react-native"
import LanguageSelector from "./LanguageSelector"

const ForeignLanguageStep = (props) => {
    const {
        field,
        formValues,
        setFormValues,
        goToNextStep,
        errors,
        setError,
        schoolSubjects,
    } = props

    const dimensions = useContext(DimensionsContext)
    const availableLanguages =
        schoolSubjects
            ?.filter((ss) => ss?.category === "language")
            ?.map((x) => {
                return { icon: x?.icon, value: x.id, label: x.name }
            }) || []

    const selectedLanguages = field.value || []
    const hasError = errors && errors["foreign_languages"]

    const allLanguagesHaveProficiency = selectedLanguages.every(
        (lang) => lang.proficiency !== undefined && lang.proficiency !== null
    )
    const canProceed =
        selectedLanguages.length === 0 || allLanguagesHaveProficiency

    const languageErrors = {}
    if (hasError && hasError.type === "proficiency_required") {
        selectedLanguages.forEach((lang) => {
            if (lang.proficiency === undefined || lang.proficiency === null) {
                languageErrors[`language_${lang.id}_proficiency`] = {
                    message: "Niveau requis",
                }
            }
        })
    }

    const selectedLanguagesForDisplay = selectedLanguages
        .map((storedLang) => {
            const fullLanguage = availableLanguages.find(
                (lang) => lang.value === storedLang.id
            )
            return fullLanguage
                ? {
                      ...fullLanguage,
                      proficiency: storedLang.proficiency,
                  }
                : null
        })
        .filter(Boolean)

    const handleLanguagesChange = (languages) => {
        const transformedLanguages = languages.map((lang) => ({
            id: lang.value,
            proficiency: lang.proficiency,
        }))

        field.onChange(transformedLanguages)

        setFormValues({
            ...formValues,
            foreign_languages: transformedLanguages,
        })

        const allHaveProficiency = transformedLanguages.every(
            (lang) =>
                lang.proficiency !== undefined && lang.proficiency !== null
        )
        if (allHaveProficiency && hasError) {
            setError("foreign_languages", undefined)
        }
    }

    const handleContinue = () => {
        if (!canProceed) {
            const languagesWithoutProficiency = selectedLanguages.filter(
                (lang) =>
                    lang.proficiency === undefined || lang.proficiency === null
            )

            if (languagesWithoutProficiency.length > 0) {
                setError("foreign_languages", {
                    type: "proficiency_required",
                    message:
                        "Veuillez sélectionner le niveau de maîtrise pour chaque langue",
                })
            }
            return
        }
        goToNextStep()
    }

    return (
        <View style={{ flex: 1, width: "100%", alignItems: "center" }}>
            <ScrollView
                style={{ flex: 1, width: "100%" }}
                contentContainerStyle={{
                    alignItems: "center",
                    paddingTop: 10,
                    paddingBottom: 20,
                }}
                keyboardShouldPersistTaps="handled"
            >
                <LanguageSelector
                    selectedLanguages={selectedLanguagesForDisplay}
                    onLanguagesChange={handleLanguagesChange}
                    availableLanguages={availableLanguages}
                    languageErrors={languageErrors}
                />

                {hasError && (
                    <View
                        style={{
                            marginTop: 10,
                            paddingHorizontal: 10,
                            alignItems: "center",
                        }}
                    >
                        <TextM
                            color={theme.colors.error}
                            fontSize={14}
                            fontWeight="Medium"
                            style={{ textAlign: "center" }}
                            wrap
                        >
                            {hasError.message}
                        </TextM>
                    </View>
                )}
            </ScrollView>

            <View
                style={{
                    width: dimensions?.width - 40,
                    alignItems: "center",
                    backgroundColor: theme.colors.whiteTransparentMore,
                    paddingVertical: 15,
                }}
            >
                <FilledButtonM
                    color={theme.colors.primary}
                    onPress={handleContinue}
                    style={{
                        width: dimensions?.width - 60,
                        alignSelf: "center",
                    }}
                    label="Continuer"
                />
            </View>
        </View>
    )
}

export default ForeignLanguageStep
